"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const use_pusher_1 = require("@harelpls/use-pusher");
const axios_1 = __importDefault(require("axios"));
const Pusher = (props) => {
    const config = {
        // required config props
        // @ts-ignore
        clientKey: window.PUSHER_APP_KEY,
        cluster: 'eu',
        // required for private/presence channels
        // also sends auth headers to trigger endpoint
        authEndpoint: '/api/broadcasting/auth',
        authorizer: (channel, options) => ({
            authorize: async (socketId, callback) => {
                try {
                    const { data } = await axios_1.default.post(options.authEndpoint, { socket_id: socketId, channel_name: channel.name });
                    callback(false, data);
                }
                catch (e) {
                    callback(true);
                }
            }
        })
    };
    return (react_1.default.createElement(use_pusher_1.PusherProvider, { ...config }, props.children));
};
exports.default = Pusher;
